import { useEffect, useState } from 'react';
import { ApiPostLoginCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { HideLoder, origin, RemoveAllCookies, ShowLoder } from '../../JS/Common';
import { useMsal } from '@azure/msal-react';
import { log } from '../../JS/Logger';
import { useDispatch } from 'react-redux';
import { setCsvUserID, setJwtToken, setSchoolId, setUserId } from '../../Store/Slices/authSlice';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';

export const MicrosoftLoginForm = (props) => {
    const { enterprise_flag } = useConfig();
    const [alerts, setAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [hasRegistered, setHasRegistered] = useState(false);
    const reduxDispatch = useDispatch();
    useEffect(() => {
        RemoveAllCookies();
    }, []);
    const { instance } = useMsal();
    const login = async () => {
        try {
            const loginResponse = await instance.loginPopup({
                scopes: ["user.read", "email", "openid", "profile"]
            });

            const account = loginResponse.account;
            if (hasRegistered) return;

            setHasRegistered(true);
            setLoading(true);
            const raw = JSON.stringify({
                name: account.name,
                email: account.username,
                googleId: null,
                microsoftId: account.localAccountId,
                ssoId: loginResponse.accessToken,
                flag: 2,
                enterpriseFlag: enterprise_flag

            });
            const result = await ApiPostLoginCall("/login", raw, true);

            if (!result) {
                setAlerts(<AlertsComp show={true} variant="danger" msg={'Login Failed!'} />);
                setTimeout(() => {
                    setAlerts(<AlertsComp show={false} />);
                }, 3000);
                return;
            }
            const responseRs = JSON.parse(result.data);
            setLoading(false);

            if (responseRs.status === "success") {
                const expires = 1;
                const authHeader = result?.headers?.authorization || '';
                const headerToken = authHeader.startsWith('Bearer ') ? authHeader.slice(7) : authHeader;
                const jwtToken = headerToken || null;
                reduxDispatch(setJwtToken(jwtToken));
                reduxDispatch(setUserId(responseRs?.msg?.id));
                reduxDispatch(setCsvUserID(responseRs.msg.id));
                reduxDispatch(setSchoolId(responseRs.msg.school_id));
                props.alertcolor("green");
                props.alertmsg(`Authentication successful! Redirecting to the home page...`);

                setTimeout(() => {
                    const userRoleKey = responseRs.msg?.accesstype || null;
                    if (hasRoleAccess(userRoleKey, RoleEnum.ALL_ADMINS)) {
                        window.location = '/school-tickets';
                    } else {
                        window.location.href = '/';
                    }
                }, 1500);
            } else {
                props.alertcolor("red");
                props.alertmsg(responseRs.response);
                setHasRegistered(false);
            }
        } catch (error) {
            log.error("Microsoft Login failed", error);
        }
    };
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            {alerts}
            <div onClick={login} style={{
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: loading || hasRegistered ? 'none' : 'auto',
                opacity: loading || hasRegistered ? 0.6 : 1,
                alignItems: 'center', color: '#000000', padding: '10px 25px',
                boxShadow: 'none', border: '1px solid #e2e3e4', fontSize: '13px', background: '#f9fafb', borderRadius: '16px', fontFamily: 'Poppins, sans-serif',
                cursor: 'pointer', width: '100%'
            }}>
                <img src="/images/MicrosoftBtn.svg" alt="Microsoft" className="img-fluid pe-3" />
                <span>Connect with Microsoft</span>
            </div>
        </>
    );
};




